// Category templates — each shop type's name, hint and tips (tpl.<key>.*), then every
// category word the templates use (cat.N, first appearance). GENERATED from
// lib/category-templates.ts, which stays the Georgian source; a test pins them equal.
export const templates = {
  'tpl.grocery.name': 'უბნის მაღაზია / სასურსათო',
  'tpl.grocery.hint': 'სასმელი, სურსათი, რძის ნაწარმი, საყოფაცხოვრებო',
  'tpl.grocery.tip1': 'ნისია — ჩაწერე კლიენტი; ვის რამდენი მართებს, დილის ანგარიშშიც ჩანს.',
  'tpl.grocery.tip2': 'ყველს ან ძეხვს წონით ყიდი? ჩართე სასწორი: პარამეტრები → ელექტრო სასწორი.',
  'tpl.produce.name': 'ხორცი / ხილი-ბოსტნეული',
  'tpl.produce.hint': 'ხორცი, ფრინველი, ხილი, ბოსტნეული, მწვანილი — წონით',
  'tpl.produce.tip1': 'სასწორის ეტიკეტი სკანერით პირდაპირ კალათაში ემატება — წონით ან ფასით.',
  'tpl.produce.tip2': 'პროდუქტს მიუთითე ერთეული „კგ" და PLU კოდი — სასწორი მას ამ კოდით ცნობს.',
  'tpl.produce.tip3': 'ელექტრო სასწორი არ გაქვს? სალაროში პროდუქტზე დააჭირე — წონას ან თანხას თვითონ გკითხავს.',
  'tpl.produce.tip4': 'ტუშს თვითონ ჭრი? „დაშლა": ტუში → რბილობი, ნეკნი, დაკეპილი ხორცი — თვითღირებულება ნაწილებზე გასაყიდი ფასით ნაწილდება.',
  'tpl.poultry.name': 'ქათმის ნაწარმი',
  'tpl.poultry.hint': 'ქათამი, ფილე, ფრთა, გულ-ღვიძლი, ინდაური, კვერცხი — წონით',
  'tpl.poultry.tip1': 'სალაროში პროდუქტზე დააჭირე და ჩაწერე წონა — ან თანხა: „₾10-ის ფრთები". ელექტრო სასწორი საჭირო არ არის.',
  'tpl.poultry.tip2': 'ქათამი წონას კარგავს? პარტიის ბოლოს დარჩენილი ჩამოწერე ან აღწერა გააკეთე — ნაშთი და მოგება ზუსტი დარჩება.',
  'tpl.poultry.tip3': 'კვერცხი კასეტით შემოდის და ცალობით იყიდება? გამოიყენე „დაშლა": 1 კასეტა = 30 ცალი.',
  'tpl.kiosk.name': '24 საათიანი ბუთიკი / drive',
  'tpl.kiosk.hint': 'სასმელი, სიგარეტი, ცხელი ყავა, სწრაფი წასახემსებელი',
  'tpl.kiosk.tip1': 'ყავის ჭიქა და თავსახური ყავის „თანმხლებ (კომბო)" პროდუქტად დაამატე — მარაგი თვითონ ჩამოიწერება.',
  'tpl.kiosk.tip2': 'სიგარეტი ბლოკით შემოდის და კოლოფით იყიდება? გამოიყენე „დაშლა".',
  'tpl.household.name': 'საყოფაცხოვრებო ნივთები',
  'tpl.household.hint': 'ქიმია, დასუფთავება, ჭურჭელი, აბაზანა, ტექსტილი',
  'tpl.household.tip1': 'ბევრი პროდუქტი გაქვს? Excel-ით შემოიტანე: საწყობი → Excel → იმპორტი.',
  'tpl.household.tip2': 'ნაკრები ცალობითაც იყიდება? „დაშლა": 1 ნაკრები → 6 თეფში.',
  'tpl.autoparts.name': 'ავტონაწილები',
  'tpl.autoparts.hint': 'ზეთი, ფილტრი, ხუნდები, საკიდარი, ელექტრო, ძარა, მეორადი',
  'tpl.autoparts.tip1': 'RS.GE-ის ზედნადებიდან მიღებისას მომწოდებლის კოდი პროდუქტს ებმება — შემდეგ ზედნადებზე აპი თვითონ იცნობს.',
  'tpl.autoparts.tip2': 'პროდუქტზე ჩაწერე, რომელ მანქანას ერგება და მისი OEM ნომრები — სალაროში „astra 2008"-ით ან ნომრით მოიძებნება, გათავებულზე კი ანალოგს შემოგთავაზებს.',
  'tpl.petshop.name': 'ზოო მაღაზია',
  'tpl.petshop.hint': 'ძაღლი, კატა, ფრინველი, თევზი, მღრღნელი — საკვები, მოვლა, აქსესუარი',
  'tpl.petshop.tip1': 'საკვები ტომრით შემოდის და კილოგრამით იყიდება? გამოიყენე „დაშლა" და ჩართე სასწორი.',
  'tpl.accessories.name': 'ტელეფონის აქსესუარები',
  'tpl.accessories.hint': 'დამტენი, კაბელი, ყურსასმენი, ჩეხოლი',
  'tpl.accessories.tip1': 'პროდუქტის ფოტო სალაროში ჩანს — მოლარე სწრაფად პოულობს.',
  'tpl.accessories.tip2': 'შტრიხკოდის ეტიკეტი საწყობიდან იბეჭდება: „ეტიკეტები".',
  'tpl.accessories.tip3': 'შუშის დაკვრა ან სხვა სამუშაო — დაამატე მომსახურებად: მარაგს არ ითვლის.',
  'tpl.accessories.tip4': 'ქეისზე ან მინაზე ჩაწერე ტელეფონის მოდელი („ერგება") — სალაროში „iphone 15"-ით მოიძებნება.',
  'tpl.coffee.name': 'ყავა / კაფე',
  'tpl.coffee.hint': 'ცხელი და ცივი სასმელი, ნამცხვარი, ერთჯერადი',
  'tpl.coffee.tip1': 'რძე, სიროფი, ჭიქა — სასმელის „თანმხლებ (კომბო)" პროდუქტად დაამატე; სალარო თვითონ შემოგთავაზებს.',
  'tpl.coffee.tip2': 'ჭიქა ₾0-ად შეიძლება — თვითღირებულება მოგებაში მაინც ჩაითვლება.',
  'tpl.stationery.name': 'საკანცელარიო / წიგნები',
  'tpl.stationery.hint': 'საწერი, რვეული, ქაღალდი, სასკოლო, სახატავი, წიგნები',
  'tpl.stationery.tip1': 'ბევრი წვრილმანი გაქვს? Excel-ით შემოიტანე: საწყობი → Excel → იმპორტი.',
  'tpl.stationery.tip2': 'ასლი, ბეჭდვა, ლამინირება — დაამატე მომსახურებად: სალარო ყიდის, მარაგს არ ითვლის.',
  'tpl.cosmetics.name': 'კოსმეტიკა / პარფიუმერია',
  'tpl.cosmetics.hint': 'სახის, თმის, სხეულის მოვლა, დეკორატიული, სუნამო',
  'tpl.cosmetics.tip1': 'პროდუქტს ვადა მიუთითე — ვადის გასვლამდე 14 დღით ადრე გაგაფრთხილებთ.',
  'tpl.clothing.name': 'ტანსაცმელი / ფეხსაცმელი',
  'tpl.clothing.hint': 'ქალის, მამაკაცის, საბავშვო, ფეხსაცმელი, აქსესუარები',
  'tpl.clothing.tip1': 'ზომები და ფერები — „მოდელად": საწყობი → „მოდელი". თითო ზომას თავისი მარაგი და შტრიხკოდი აქვს, სალაროში კი მოდელი ერთ ბარათად ჩანს.',
  'tpl.clothing.tip2': 'მომწოდებლის შტრიხკოდი არ აქვს? აპი მაღაზიის კოდს თვითონ შექმნის და ეტიკეტს დაბეჭდავს.',
  'tpl.hardware.name': 'სამშენებლო / ხელსაწყოები',
  'tpl.hardware.hint': 'ხელსაწყოები, სამაგრები, საღებავი, ელექტროობა, სანტექნიკა',
  'tpl.hardware.tip1': 'მეტრით ან კილოგრამით ყიდი? რაოდენობა წილადითაც ჩაიწერება: 2.5 მ.',
  'cat.1': 'გაზიანი სასმელები',
  'cat.2': 'ბორჯომი',
  'cat.3': 'ნაბეღლავი',
  'cat.4': 'ლიკანი',
  'cat.5': 'საირმე',
  'cat.6': 'კოკა-კოლა',
  'cat.7': 'ფანტა',
  'cat.8': 'წვენი და წყალი',
  'cat.9': 'წვენი',
  'cat.10': 'სასმელი წყალი',
  'cat.11': 'მინერალური წყალი',
  'cat.12': 'ენერგეტიკული სასმელები',
  'cat.13': 'ალკოჰოლური სასმელები',
  'cat.14': 'ლუდი',
  'cat.15': 'ღვინო',
  'cat.16': 'არაყი',
  'cat.17': 'კონიაკი',
  'cat.18': 'სიგარეტი',
  'cat.19': 'WINSTON',
  'cat.20': 'MARLBORO',
  'cat.21': 'PARLIAMENT',
  'cat.22': 'CAMEL',
  'cat.23': 'KENT',
  'cat.24': 'სურსათი',
  'cat.25': 'ძეხვეული',
  'cat.26': 'პური',
  'cat.27': 'პელმენი',
  'cat.28': 'ხინკალი',
  'cat.29': 'კუპატი',
  'cat.30': 'კონსერვი',
  'cat.31': 'რძის ნაწარმი',
  'cat.32': 'მაწონი',
  'cat.33': 'რძე',
  'cat.34': 'არაჟანი',
  'cat.35': 'ხაჭო',
  'cat.36': 'ყველი',
  'cat.37': 'კარაქი',
  'cat.38': 'ნაყინი',
  'cat.39': 'ტკბილეული',
  'cat.40': 'შოკოლადი',
  'cat.41': 'ორცხობილა',
  'cat.42': 'საღეჭი რეზინი',
  'cat.43': 'ჩიფსი და კრეკერი',
  'cat.44': 'ყავა და ჩაი',
  'cat.45': 'ხსნადი ყავა',
  'cat.46': 'ჩაი',
  'cat.47': 'ცხელი ყავა',
  'cat.48': 'საყოფაცხოვრებო',
  'cat.49': 'ქიმია',
  'cat.50': 'ერთჯერადი ჭურჭელი',
  'cat.51': 'პარკები',
  'cat.52': 'თავის მოვლა',
  'cat.53': 'სხვადასხვა',
  'cat.54': 'ხორცი',
  'cat.55': 'საქონლის',
  'cat.56': 'ღორის',
  'cat.57': 'ხბოს',
  'cat.58': 'ცხვრის',
  'cat.59': 'ფარში',
  'cat.60': 'ფრინველი',
  'cat.61': 'ქათამი',
  'cat.62': 'ინდაური',
  'cat.63': 'ფრთა და ბარკალი',
  'cat.64': 'ხილი',
  'cat.65': 'ვაშლი',
  'cat.66': 'ბანანი',
  'cat.67': 'ციტრუსი',
  'cat.68': 'ყურძენი',
  'cat.69': 'სეზონური',
  'cat.70': 'ბოსტნეული',
  'cat.71': 'კარტოფილი',
  'cat.72': 'პომიდორი',
  'cat.73': 'კიტრი',
  'cat.74': 'ხახვი და ნიორი',
  'cat.75': 'კომბოსტო',
  'cat.76': 'მწვანილი',
  'cat.77': 'თხილეული და ჩირი',
  'cat.78': 'კვერცხი',
  'cat.79': 'ყველი და რძის ნაწარმი',
  'cat.80': 'იმერული',
  'cat.81': 'სულგუნი',
  'cat.82': 'ნადუღი',
  'cat.83': 'სანელებელი',
  'cat.84': 'ერთჯერადი',
  'cat.85': 'ჭიქა',
  'cat.86': 'თავსახური',
  'cat.87': 'ჩხირი',
  'cat.88': 'წასახემსებელი',
  'cat.89': 'სარეცხი საშუალებები',
  'cat.90': 'სარეცხი ფხვნილი',
  'cat.91': 'სარეცხი გელი',
  'cat.92': 'კონდიციონერი',
  'cat.93': 'მათეთრებელი',
  'cat.94': 'ლაქის ამომყვანი',
  'cat.95': 'დასუფთავება',
  'cat.96': 'იატაკის საწმენდი',
  'cat.97': 'სამზარეულოს საწმენდი',
  'cat.98': 'სანტექნიკის საწმენდი',
  'cat.99': 'მინის საწმენდი',
  'cat.100': 'უნივერსალური',
  'cat.101': 'ჭურჭლის რეცხვა',
  'cat.102': 'ჭურჭლის სითხე',
  'cat.103': 'ღრუბელი და ტილო',
  'cat.104': 'ჭურჭლის მანქანის ტაბლეტი',
  'cat.105': 'დასუფთავების ინვენტარი',
  'cat.106': 'ცოცხი და აქანდაზი',
  'cat.107': 'ჩოგანი',
  'cat.108': 'ვედრო',
  'cat.109': 'ხელთათმანი',
  'cat.110': 'მტვრის ტილო',
  'cat.111': 'ჭურჭელი',
  'cat.112': 'თეფში',
  'cat.113': 'ჭიქა და ფინჯანი',
  'cat.114': 'ქვაბი',
  'cat.115': 'ტაფა',
  'cat.116': 'დანა-ჩანგალი',
  'cat.117': 'კონტეინერი',
  'cat.118': 'სამზარეულოს წვრილმანი',
  'cat.119': 'საჭრელი დაფა',
  'cat.120': 'სახეხი და საწური',
  'cat.121': 'ფოლგა და ცელოფანი',
  'cat.122': 'თერმოსი',
  'cat.123': 'ჩაიდანი',
  'cat.124': 'აბაზანა და ტუალეტი',
  'cat.125': 'ტუალეტის ქაღალდი',
  'cat.126': 'საპონი',
  'cat.127': 'ტუალეტის საწმენდი',
  'cat.128': 'ჰაერის არომატიზატორი',
  'cat.129': 'აბაზანის აქსესუარები',
  'cat.130': 'პარკები და ერთჯერადი',
  'cat.131': 'ნაგვის პარკი',
  'cat.132': 'ხელსახოცი',
  'cat.133': 'საკვების პარკი',
  'cat.134': 'ტექსტილი',
  'cat.135': 'პირსახოცი',
  'cat.136': 'ზეწარი და ბალიშისპირი',
  'cat.137': 'საფენი',
  'cat.138': 'ფარდა',
  'cat.139': 'მაგიდის გადასაფარებელი',
  'cat.140': 'ელექტრო წვრილმანი',
  'cat.141': 'ნათურა',
  'cat.142': 'ბატარეა',
  'cat.143': 'დამაგრძელებელი',
  'cat.144': 'სანთელი და სანთებელა',
  'cat.145': 'სახლის მოწყობა',
  'cat.146': 'საკიდი',
  'cat.147': 'შესანახი ყუთი',
  'cat.148': 'კალათა',
  'cat.149': 'სარკე',
  'cat.150': 'საათი',
  'cat.151': 'მავნებლების წინააღმდეგ',
  'cat.152': 'მწერების საწინააღმდეგო',
  'cat.153': 'თაგვის ხაფანგი',
  'cat.154': 'ჩრჩილის საწინააღმდეგო',
  'cat.155': 'ბაღი და სეზონური',
  'cat.156': 'ყვავილის ქოთანი',
  'cat.157': 'სარწყავი',
  'cat.158': 'საახალწლო',
  'cat.159': 'ზაფხულის',
  'cat.160': 'ზეთი და სითხე',
  'cat.161': 'ძრავის ზეთი',
  'cat.162': 'კოლოფის ზეთი',
  'cat.163': 'ანტიფრიზი',
  'cat.164': 'სამუხრუჭე სითხე',
  'cat.165': 'ჰიდრავლიკის ზეთი',
  'cat.166': 'მინის სარეცხი სითხე',
  'cat.167': 'დანამატი',
  'cat.168': 'ფილტრი',
  'cat.169': 'ზეთის ფილტრი',
  'cat.170': 'ჰაერის ფილტრი',
  'cat.171': 'საწვავის ფილტრი',
  'cat.172': 'სალონის ფილტრი',
  'cat.173': 'სამუხრუჭე სისტემა',
  'cat.174': 'ხუნდები',
  'cat.175': 'სამუხრუჭე დისკი',
  'cat.176': 'სამუხრუჭე დოლი',
  'cat.177': 'სუპორტი',
  'cat.178': 'სამუხრუჭე მილი',
  'cat.179': 'ABS სენსორი',
  'cat.180': 'საკიდარი',
  'cat.181': 'ამორტიზატორი',
  'cat.182': 'ზამბარა',
  'cat.183': 'ბერკეტი',
  'cat.184': 'ბურთულა სახსარი',
  'cat.185': 'სტაბილიზატორის ჯოხი',
  'cat.186': 'ამორტიზატორის საყრდენი',
  'cat.187': 'სალენტი',
  'cat.188': 'ბორბლის საკისარი',
  'cat.189': 'საჭე და ამძრავი',
  'cat.190': 'საჭის წვერი',
  'cat.191': 'საჭის მექანიზმი',
  'cat.192': 'საჭის ტუმბო',
  'cat.193': 'გრანატა',
  'cat.194': 'ნახევარღერძი',
  'cat.195': 'კარდანი',
  'cat.196': 'ძრავი',
  'cat.197': 'ღვედი',
  'cat.198': 'ღვედის დამჭიმი',
  'cat.199': 'გამანაწილებელი ღვედი / ჯაჭვი',
  'cat.200': 'წყლის ტუმბო',
  'cat.201': 'თერმოსტატი',
  'cat.202': 'სანთელი',
  'cat.203': 'ანთების კოჭა',
  'cat.204': 'შუასადები',
  'cat.205': 'ძრავის ბალიში',
  'cat.206': 'გაგრილება და კონდიციონერი',
  'cat.207': 'რადიატორი',
  'cat.208': 'ვენტილატორი',
  'cat.209': 'ღუმელის რადიატორი',
  'cat.210': 'კონდიციონერის კომპრესორი',
  'cat.211': 'მილი და შლანგი',
  'cat.212': 'გადაბმულობა და კოლოფი',
  'cat.213': 'გადაბმულობის ნაკრები',
  'cat.214': 'მაქოვანა',
  'cat.215': 'გადაბმულობის ცილინდრი',
  'cat.216': 'კოლოფის ბალიში',
  'cat.217': 'გამონაბოლქვი',
  'cat.218': 'მაყუჩი',
  'cat.219': 'კატალიზატორი',
  'cat.220': 'ლამბდა ზონდი',
  'cat.221': 'გამონაბოლქვის მილი',
  'cat.222': 'გოფრი',
  'cat.223': 'ელექტრო',
  'cat.224': 'აკუმულატორი',
  'cat.225': 'გენერატორი',
  'cat.226': 'სტარტერი',
  'cat.227': 'სენსორი',
  'cat.228': 'რელე და დამცავი',
  'cat.229': 'გაყვანილობა',
  'cat.230': 'საწმენდის ძრავა',
  'cat.231': 'განათება',
  'cat.232': 'წინა ფარი',
  'cat.233': 'უკანა ფარი',
  'cat.234': 'ნისლის ფარი',
  'cat.235': 'LED',
  'cat.236': 'მოსახვევის მაჩვენებელი',
  'cat.237': 'ძარა',
  'cat.238': 'ბამპერი',
  'cat.239': 'ფრთა',
  'cat.240': 'კაპოტი',
  'cat.241': 'კარი',
  'cat.242': 'გისოსი',
  'cat.243': 'საბარგულის სახურავი',
  'cat.244': 'ზღურბლი',
  'cat.245': 'მინა და საწმენდი',
  'cat.246': 'საქარე მინა',
  'cat.247': 'გვერდითი მინა',
  'cat.248': 'უკანა მინა',
  'cat.249': 'საწმენდი (ჯაგრისი)',
  'cat.250': 'საბურავი და დისკი',
  'cat.251': 'საბურავი ზაფხულის',
  'cat.252': 'საბურავი ზამთრის',
  'cat.253': 'დისკი',
  'cat.254': 'ბოლტი და ქანჩი',
  'cat.255': 'ბალანსირების ტვირთი',
  'cat.256': 'დისკის ხუფი',
  'cat.257': 'სალონი',
  'cat.258': 'სავარძლის ჩეხოლი',
  'cat.259': 'ხალიჩა',
  'cat.260': 'საჭის ჩეხოლი',
  'cat.261': 'არომატიზატორი',
  'cat.262': 'ტელეფონის სამაგრი',
  'cat.263': 'მზის დამცავი',
  'cat.264': 'ავტოქიმია და მოვლა',
  'cat.265': 'პოლიროლი',
  'cat.266': 'ავტოშამპუნი',
  'cat.267': 'WD-40 და შემზეთი',
  'cat.268': 'ანტიკოროზიული',
  'cat.269': 'სალონის საწმენდი',
  'cat.270': 'აქსესუარი და ინსტრუმენტი',
  'cat.271': 'ბუქსირის ბაგირი',
  'cat.272': 'დამტენი სადენი',
  'cat.273': 'კომპრესორი (ტუმბო)',
  'cat.274': 'ამწე (დომკრატი)',
  'cat.275': 'ცეცხლმაქრი',
  'cat.276': 'სამედიცინო ყუთი',
  'cat.277': 'გასაღებების ნაკრები',
  'cat.278': 'მეორადი ნაწილი',
  'cat.279': 'გადაცემათა კოლოფი',
  'cat.280': 'ფარი',
  'cat.281': 'საკიდარის ნაწილი',
  'cat.282': 'სალონის ნაწილი',
  'cat.283': 'ძაღლის საკვები',
  'cat.284': 'მშრალი საკვები',
  'cat.285': 'სველი საკვები',
  'cat.286': 'ლეკვის საკვები',
  'cat.287': 'წამახალისებელი',
  'cat.288': 'ძვალი და საღეჭი',
  'cat.289': 'კატის საკვები',
  'cat.290': 'კნუტის საკვები',
  'cat.291': 'ძაღლის მოვლა',
  'cat.292': 'შამპუნი',
  'cat.293': 'სავარცხელი და ჯაგრისი',
  'cat.294': 'ბრჭყალის საკვნეტი',
  'cat.295': 'პირის ღრუს მოვლა',
  'cat.296': 'კატის მოვლა',
  'cat.297': 'ქვიშა',
  'cat.298': 'ქვიშის ყუთი და ნიჩაბი',
  'cat.299': 'სავარცხელი',
  'cat.300': 'საფხეკი',
  'cat.301': 'ძაღლის აქსესუარი',
  'cat.302': 'საყელო',
  'cat.303': 'საბელი (გასასეირნებელი)',
  'cat.304': 'შლეიკა',
  'cat.305': 'ალიკაპი',
  'cat.306': 'ტანსაცმელი',
  'cat.307': 'სათამაშო',
  'cat.308': 'საწოლი',
  'cat.309': 'კატის აქსესუარი',
  'cat.310': 'საწოლი და სახლი',
  'cat.311': 'გადასაყვანი ჩანთა',
  'cat.312': 'თასი',
  'cat.313': 'ავტომატური საკვებური',
  'cat.314': 'წყლის შადრევანი',
  'cat.315': 'თუთიყუშის საკვები',
  'cat.316': 'კანარის საკვები',
  'cat.317': 'გალია',
  'cat.318': 'გალიის აქსესუარი',
  'cat.319': 'ვიტამინი',
  'cat.320': 'თევზი და აკვარიუმი',
  'cat.321': 'თევზის საკვები',
  'cat.322': 'აკვარიუმი',
  'cat.323': 'ფილტრი და ტუმბო',
  'cat.324': 'გამათბობელი',
  'cat.325': 'გრუნტი და დეკორი',
  'cat.326': 'წყლის საშუალება',
  'cat.327': 'მღრღნელი და ბოცვერი',
  'cat.328': 'საკვები',
  'cat.329': 'თივა და საფენი',
  'cat.330': 'სათამაშო და ბორბალი',
  'cat.331': 'ქვეწარმავალი',
  'cat.332': 'ტერარიუმი',
  'cat.333': 'განათება და გათბობა',
  'cat.334': 'ვეტერინარია',
  'cat.335': 'ჭიის საწინააღმდეგო',
  'cat.336': 'რწყილისა და ტკიპის საწინააღმდეგო',
  'cat.337': 'ვიტამინი და დანამატი',
  'cat.338': 'ჭრილობის მოვლა',
  'cat.339': 'პრობიოტიკი',
  'cat.340': 'ტრანსპორტირება',
  'cat.341': 'გადასაყვანი ყუთი',
  'cat.342': 'ჩანთა',
  'cat.343': 'მანქანის საფენი',
  'cat.344': 'დამტენი',
  'cat.345': 'კედლის დამტენი',
  'cat.346': 'ავტო დამტენი',
  'cat.347': 'უსადენო',
  'cat.348': 'კაბელი',
  'cat.349': 'Type-C',
  'cat.350': 'Lightning',
  'cat.351': 'Micro USB',
  'cat.352': 'ყურსასმენი',
  'cat.353': 'სადენიანი',
  'cat.354': 'Power Bank',
  'cat.355': 'ჩეხოლი',
  'cat.356': 'დამცავი შუშა',
  'cat.357': 'SIM ბარათი',
  'cat.358': 'მეხსიერების ბარათი',
  'cat.359': 'სათადარიგო ნაწილები',
  'cat.360': 'ცხელი სასმელი',
  'cat.361': 'ესპრესო',
  'cat.362': 'ამერიკანო',
  'cat.363': 'კაპუჩინო',
  'cat.364': 'ლატე',
  'cat.365': 'ცხელი შოკოლადი',
  'cat.366': 'ცივი სასმელი',
  'cat.367': 'ყინულოვანი ყავა',
  'cat.368': 'ლიმონათი',
  'cat.369': 'წყალი',
  'cat.370': 'ნამცხვარი და დესერტი',
  'cat.371': 'კრუასანი',
  'cat.372': 'ნამცხვარი',
  'cat.373': 'სენდვიჩი',
  'cat.374': 'ნედლეული',
  'cat.375': 'ყავის მარცვალი',
  'cat.376': 'სიროფი',
  'cat.377': 'შაქარი',
  'cat.378': 'საწერი',
  'cat.379': 'კალამი',
  'cat.380': 'ფანქარი',
  'cat.381': 'მარკერი',
  'cat.382': 'ფლომასტერი',
  'cat.383': 'საშლელი',
  'cat.384': 'სათლელი',
  'cat.385': 'რვეული და ბლოკნოტი',
  'cat.386': 'რვეული',
  'cat.387': 'ბლოკნოტი',
  'cat.388': 'დღიური',
  'cat.389': 'ესკიზების რვეული',
  'cat.390': 'ქაღალდი',
  'cat.391': 'A4 ქაღალდი',
  'cat.392': 'ფერადი ქაღალდი',
  'cat.393': 'სტიკერი',
  'cat.394': 'კონვერტი',
  'cat.395': 'საქაღალდე',
  'cat.396': 'ფაილი',
  'cat.397': 'რეგისტრატორი',
  'cat.398': 'ორგანაიზერი',
  'cat.399': 'სასკოლო',
  'cat.400': 'პენალი',
  'cat.401': 'სახაზავი',
  'cat.402': 'ფარგალი',
  'cat.403': 'ტრანსპორტირი',
  'cat.404': 'სახატავი',
  'cat.405': 'ფერადი ფანქარი',
  'cat.406': 'აკვარელი',
  'cat.407': 'გუაში',
  'cat.408': 'ფუნჯი',
  'cat.409': 'პლასტილინი',
  'cat.410': 'ალბომი',
  'cat.411': 'საოფისე',
  'cat.412': 'სტეპლერი',
  'cat.413': 'სკოჩი',
  'cat.414': 'წებო',
  'cat.415': 'მაკრატელი',
  'cat.416': 'კალკულატორი',
  'cat.417': 'სამაგრი',
  'cat.418': 'წიგნები',
  'cat.419': 'სახელმძღვანელო',
  'cat.420': 'მხატვრული',
  'cat.421': 'საბავშვო',
  'cat.422': 'ლექსიკონი',
  'cat.423': 'სასაჩუქრე',
  'cat.424': 'შესაფუთი ქაღალდი',
  'cat.425': 'ბაფთა',
  'cat.426': 'მისალოცი ბარათი',
  'cat.427': 'სასაჩუქრე პარკი',
  'cat.428': 'სახის მოვლა',
  'cat.429': 'კრემი',
  'cat.430': 'შრატი',
  'cat.431': 'ნიღაბი',
  'cat.432': 'ტონიკი',
  'cat.433': 'დასაბანი',
  'cat.434': 'მზისგან დამცავი',
  'cat.435': 'დეკორატიული კოსმეტიკა',
  'cat.436': 'ტონალური კრემი',
  'cat.437': 'პუდრა',
  'cat.438': 'ტუში',
  'cat.439': 'ტუჩსაცხი',
  'cat.440': 'ლაინერი',
  'cat.441': 'ჩრდილები',
  'cat.442': 'ღაწვების საღებავი',
  'cat.443': 'თმის მოვლა',
  'cat.444': 'თმის ნიღაბი',
  'cat.445': 'ლაქი და მუსი',
  'cat.446': 'თმის საღებავი',
  'cat.447': 'სხეულის მოვლა',
  'cat.448': 'ლოსიონი',
  'cat.449': 'სკრაბი',
  'cat.450': 'დეზოდორანტი',
  'cat.451': 'შხაპის გელი',
  'cat.452': 'პარფიუმერია',
  'cat.453': 'ქალის',
  'cat.454': 'მამაკაცის',
  'cat.455': 'უნისექსი',
  'cat.456': 'ფრჩხილის მოვლა',
  'cat.457': 'ფრჩხილის ლაქი',
  'cat.458': 'ლაქის მოსაშორებელი',
  'cat.459': 'ფრჩხილის ქლიბი',
  'cat.460': 'აქსესუარები',
  'cat.461': 'ღრუბელი',
  'cat.462': 'პინცეტი',
  'cat.463': 'მამაკაცისთვის',
  'cat.464': 'საპარსი',
  'cat.465': 'საპარსი ქაფი',
  'cat.466': 'პარსვის შემდგომი',
  'cat.467': 'ქალის ტანსაცმელი',
  'cat.468': 'კაბა',
  'cat.469': 'ბლუზა',
  'cat.470': 'შარვალი',
  'cat.471': 'ქვედაბოლო',
  'cat.472': 'ჟაკეტი',
  'cat.473': 'სვიტერი',
  'cat.474': 'მამაკაცის ტანსაცმელი',
  'cat.475': 'პერანგი',
  'cat.476': 'მაისური',
  'cat.477': 'ჯინსი',
  'cat.478': 'პიჯაკი',
  'cat.479': 'გოგონები',
  'cat.480': 'ბიჭები',
  'cat.481': 'ჩვილები',
  'cat.482': 'ზედა ტანსაცმელი',
  'cat.483': 'ქურთუკი',
  'cat.484': 'პალტო',
  'cat.485': 'ჟილეტი',
  'cat.486': 'საწვიმარი',
  'cat.487': 'ფეხსაცმელი',
  'cat.488': 'სპორტული',
  'cat.489': 'ჩუსტი',
  'cat.490': 'საცვალი და წინდა',
  'cat.491': 'ქალის საცვალი',
  'cat.492': 'მამაკაცის საცვალი',
  'cat.493': 'წინდა',
  'cat.494': 'კოლგოტი',
  'cat.495': 'სპორტული ფორმა',
  'cat.496': 'ლეგინსი',
  'cat.497': 'სპორტული მაისური',
  'cat.498': 'ქამარი',
  'cat.499': 'ქუდი',
  'cat.500': 'შარფი',
  'cat.501': 'სათვალე',
  'cat.502': 'ხელის ხელსაწყოები',
  'cat.503': 'ჩაქუჩი',
  'cat.504': 'სახრახნისი',
  'cat.505': 'ქანჩის გასაღები',
  'cat.506': 'მარწუხი',
  'cat.507': 'ხერხი',
  'cat.508': 'სახაზავი და დონე',
  'cat.509': 'ელექტრო ხელსაწყოები',
  'cat.510': 'დრელი',
  'cat.511': 'ელექტრო სახრახნისი',
  'cat.512': 'კუთხსახეხი',
  'cat.513': 'ელექტრო ხერხი',
  'cat.514': 'ბურღი',
  'cat.515': 'სამაგრები',
  'cat.516': 'ჭანჭიკი და ქანჩი',
  'cat.517': 'ლურსმანი',
  'cat.518': 'ხრახნი',
  'cat.519': 'დუბელი',
  'cat.520': 'ანკერი',
  'cat.521': 'საღებავი და ლაქი',
  'cat.522': 'საღებავი',
  'cat.523': 'გრუნტი',
  'cat.524': 'ლაქი',
  'cat.525': 'გორგოლაჭი',
  'cat.526': 'გამხსნელი',
  'cat.527': 'ელექტროობა',
  'cat.528': 'ჩამრთველი',
  'cat.529': 'როზეტი',
  'cat.530': 'ავტომატური ამომრთველი',
  'cat.531': 'სანტექნიკა',
  'cat.532': 'ონკანი',
  'cat.533': 'მილი და ფიტინგი',
  'cat.534': 'შლანგი',
  'cat.535': 'სიფონი',
  'cat.536': 'ვენტილი',
  'cat.537': 'სამშენებლო მასალები',
  'cat.538': 'ცემენტი',
  'cat.539': 'წებო-ცემენტი',
  'cat.540': 'ფითხი',
  'cat.541': 'ბათქაში',
  'cat.542': 'თაბაშირ-მუყაო',
  'cat.543': 'საიზოლაციო',
  'cat.544': 'სილიკონი',
  'cat.545': 'სამონტაჟო ქაფი',
  'cat.546': 'იზოლენტა',
  'cat.547': 'საიზოლაციო ლენტი',
  'cat.548': 'უსაფრთხოება',
  'cat.549': 'დამცავი სათვალე',
  'cat.550': 'რესპირატორი',
  'cat.551': 'ჩაფხუტი',
  'cat.552': 'ქათამი (მთლიანი)',
  'cat.553': 'ფილე',
  'cat.554': 'მკერდი',
  'cat.555': 'ბარკალი და ფეხი',
  'cat.556': 'გულ-ღვიძლი და კუჭი',
  'cat.557': 'ნახევარფაბრიკატი',
  'cat.558': 'სანელებელი და სოუსი',
} as const
